import { runCookieConsent } from '$lib/cookieconsent-config';
import { loadWebConfig } from '$store/api';
import { setSession } from '$store/session';
import { initClient, resetClient } from 'src/services/sdk-client';
import { getSession, loadFeatureFlags } from './shared';
import { initializeWebStore } from './stores/web.store';
import { setupSentryReplay } from './tracing/setup-sentry-replay';
import { toast } from '@zerodevx/svelte-toast';
async function renderCookieConsentAndRunAnalytics() {
	import('vanilla-cookieconsent/dist/cookieconsent.css');
	runCookieConsent(() => {
		setupSentryReplay();
	});
}

const version = '1.0.0';

export async function initializeWeb() {
	renderCookieConsentAndRunAnalytics();

	const tenantConfigInitialized = await loadWebConfig();

	if(!tenantConfigInitialized){
		setTimeout(() => {
			window.location.reload();
		}, 5000);
		return;
	}

	
	initializeWebStore(version, tenantConfigInitialized, true);
	
	resetClient();
	initClient();
	
	try {
		if (tenantConfigInitialized) {
			await loadFeatureFlags();
		}
		// initialize session
		const session = await getSession(false);
		setSession(session);
	} catch (error) {
		setSession(null);
		console.error(error);
	}

	console.log('Hello from web.ts');
}
